import { render, staticRenderFns } from "./PolicyPlacementsSelect.vue?vue&type=template&id=06531f51&scoped=true"
import script from "./PolicyPlacementsSelect.vue?vue&type=script&lang=js"
export * from "./PolicyPlacementsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06531f51",
  null
  
)

export default component.exports